export const MODULES = {
  navigation: 'nav',
  footer: 'footer',
} as const;

export type ModuleType = valueof<typeof MODULES>;

export const CTA_BUTTON_DISPLAY_TYPES = [
  'Show on desktop',
  'Show on mobile',
] as const;

export type CtaButtonDisplayOption = (typeof CTA_BUTTON_DISPLAY_TYPES)[number];
export type CtaButtonDisplayType = CtaButtonDisplayOption[];
